import { Map as ImmutableMap } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
const INITIAL_STATE = new ImmutableMap({
  isRequesting: false,
  error: false
});
export default function multiLangRequests(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.ATTACH_TO_LANG_MASTER_PENDING:
      return state.merge({
        isRequesting: true,
        error: null
      });
    case ActionTypes.ATTACH_TO_LANG_MASTER_SUCCESS:
      return state.set('isRequesting', false);
    case ActionTypes.ATTACH_TO_LANG_MASTER_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error
      });
    default:
      return state;
  }
}